/**
 * Sidebar schema for events block.
 * @module components/manage/Blocks/Events/Schema
 * @nk24:CMScom created 2021/03/30
 */

import TargetsWidget from '~/components/manage/Widgets/TargetsWidget';

const Schema = {
  title: 'Events',

  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: [],
    },
    {
      id: 'background-images',
      title: 'Background Images',
      fields: ['background_image_PC', 'background_image_SP'],
    },
  ],
  properties: {
    background_image_PC: {
      title: 'Background image for PC',
      widget: 'object_browser',
      mode: 'image',
      selectedItemAttrs: [],
    },
    background_image_SP: {
      title: 'Background image for SP',
      widget: 'object_browser',
      mode: 'image',
      selectedItemAttrs: [],
    },
  },
  required: [],
};

export default Schema;
